// Module
var code = "<th name=header data-value=arrangement.viewTypeProperties.orders translate>arrangement.viewTypeProperties.orders</th> <th name=header data-value=quantity translate>quantity</th> <th name=header data-value=arrangement.viewTypeProperties.shipmentUnitProductQuantity translate>arrangement.viewTypeProperties.shipmentUnitProductQuantity</th> ";
// Exports
module.exports = code;